/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { User } from '@app/settings/users/user.model';

export class UserRole extends Model {
  id: number;
  name: string;
  permissions: Array<any>;
  deletable: boolean;
  users?: Array<User>;
}
